module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('img', {
    staticClass: "patientList-logo",
    attrs: {
      "src": require("../../assets/LOGO.png")
    },
    on: {
      "click": _vm.home
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "patientList-user"
  }, [_c('img', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "id": "dropdown"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('label', [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('img', {
    staticClass: "patientList-drown",
    attrs: {
      "src": require("../../assets/arrow_down.png")
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "id": "dropdown-menu"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "loginOut"
    }
  }, [_vm._v(_vm._s(_vm.$t('sign out')))])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-632e9df3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common-template/CreateHCPHeader.vue
// module id = 1473
// module chunks = 7